/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewHoneypots } from './CRSFSecReviewHoneypots';
import {
    CRSFSecReviewHoneypotsFromJSON,
    CRSFSecReviewHoneypotsFromJSONTyped,
    CRSFSecReviewHoneypotsToJSON,
} from './CRSFSecReviewHoneypots';

/**
 * 
 * @export
 * @interface CRSFSecReviewHoneypotsPagedResponse
 */
export interface CRSFSecReviewHoneypotsPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewHoneypotsPagedResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewHoneypotsPagedResponse
     */
    page_size?: number;
    /**
     * 
     * @type {Array<CRSFSecReviewHoneypots>}
     * @memberof CRSFSecReviewHoneypotsPagedResponse
     */
    results?: Array<CRSFSecReviewHoneypots>;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewHoneypotsPagedResponse
     */
    total?: number;
}

/**
 * Check if a given object implements the CRSFSecReviewHoneypotsPagedResponse interface.
 */
export function instanceOfCRSFSecReviewHoneypotsPagedResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CRSFSecReviewHoneypotsPagedResponseFromJSON(json: any): CRSFSecReviewHoneypotsPagedResponse {
    return CRSFSecReviewHoneypotsPagedResponseFromJSONTyped(json, false);
}

export function CRSFSecReviewHoneypotsPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewHoneypotsPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(CRSFSecReviewHoneypotsFromJSON)),
        'total': !exists(json, 'total') ? undefined : json['total'],
    };
}

export function CRSFSecReviewHoneypotsPagedResponseToJSON(value?: CRSFSecReviewHoneypotsPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(CRSFSecReviewHoneypotsToJSON)),
        'total': value.total,
    };
}

